import styled from "styled-components";
import {SubTitle} from "@FRAMEWORK/ui/desktop/text";

const ScrollTabList = styled.ul<{isFixed?: boolean}>`
	position: sticky;
	top: 60px;
	display: flex;
	width: 100%;
	padding-top: 30px;
	background-color: #fff;
	z-index: 5;

	li {
		display: flex;
		height: 50px;
		margin-left: 1px;
		align-items: center;
		justify-content: center;
		flex: 1 1 0;
	}
	${props =>
		props.isFixed === false &&
		`
		position: static;
	`}
`;

const ScrollTabItem = styled.a<{isActive: boolean}>`
	display: flex;
	width: 100%;
	height: 100%;
	background-color: #fff;
	color: var(--emp-color);
	cursor: pointer;
	align-items: center;
	justify-content: center;
	outline: 1px solid var(--line-color);

	${props =>
		props.isActive &&
		`
		background-color: var(--emp-color);
		outline: 1px solid var(--emp-color);
		color: #fff;
	`}
`;

const ScrollContent = styled.div`
	scroll-margin: 164px;
`;

const TabListWrap = styled.div`
	padding-top: 30px;
`;

const TabContent = styled.div``;

const ContentTitle = styled(SubTitle)`
	margin: 60px 0 20px;
`;

export {ScrollTabList, ScrollTabItem, ScrollContent, TabListWrap, TabContent, ContentTitle};
